import { Placeholder, Image, Card } from "react-bootstrap";

export const Loading = () => {
  return (
    <div className="w-100">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={`el-${index}`} className="mb-0 p-3 pb-1">
          <div
            className="d-flex align-items-center"
            style={{ height: "51.16px" }}
          >
            <div className="d-flex justify-content-center align-items-center me-3">
              <div className="icon icon-md bg-light p-2">
                <Placeholder as={Image} bg="light" animation="wave" />
              </div>
            </div>
            <div className="w-100">
              <Placeholder as={Card.Title} animation="wave" className="mb-1">
                <Placeholder xs={4} className="rounded-1" />
              </Placeholder>
              <Placeholder as={Card.Text} animation="wave">
                <Placeholder size="sm" xs={6} className="rounded-1" />
              </Placeholder>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
